import { API_V1, API_V2 } from '@front-app/services/api';
import { MemberSort } from '@front-app/modules/groupMember/hooks/useSortMemberRadio';
import {
	parseGroupMember,
	parseGroupmemberCounts,
} from '@front-app/services/parse';
import {
	GroupMember,
	GroupMemberCounts,
	GroupMemberCountsResponse,
	GroupMemberResponse,
	GroupMemberWithEmail,
	UserRole,
} from '../UserApi/UserModel';

export function getGroupMembers(groupId: string): Promise<GroupMember[]> {
	return API_V1.get(`/group/${groupId}/members`)
		.then(({ data }) => data as GroupMember[]);
}

/**
 * Fetch all members with given roles. Prefer to use the paginated member API below for performance reasons
 *
 * @param groupId String - Group ID
 * @deprecated
 * @returns Promise<GroupMember[]> The list of group members
 */
export function getGroupMembersV2(groupId: string): Promise<GroupMember[]> {
	const params = { role: [UserRole.ADMINISTRATOR] };
	return API_V2.get(`/groups/${groupId}/members`, { params })
		.then(({ data }) => data as GroupMemberResponse[])
		.then((items) => items.map(parseGroupMember));
}

export function getGroupMemberPage(groupId: string, role: UserRole[], pageNum: number, sort: MemberSort): Promise<(GroupMemberWithEmail | GroupMember)[]> {
	const params = { sort, role };
	return API_V2.get(`/groups/${groupId}/members/page/${pageNum}`, { params })
		.then(({ data }) => data as GroupMemberResponse[])
		.then((items) => items.map(parseGroupMember));
}

export function getGroupMemberCounts(groupId: string): Promise<GroupMemberCounts> {
	return API_V2.get(`/groups/${groupId}/members/counts`)
		.then(({ data }) => data as GroupMemberCountsResponse)
		.then(parseGroupmemberCounts);
}

export enum GroupRoleRequest {
	ACCEPT = 'accept',
	CODE = 'code',
	CODE_AND_TERMS = 'code_and_terms',
	IGNORE = 'ignore',
	DECLINE = 'decline',
	TERMS = 'terms',
}

export async function updateGroupMemberRole(groupId: string, action: GroupRoleRequest, inviteId?: string, accessCode?: string): Promise<void> {
	const params = {
		action,
		inviteId,
		accessCode,
	};
	return API_V1.put(`/group/${groupId}/members`, undefined, { params });
}

export function removeGroupMembers(groupId: string, userIds: string[], externalUserIds: string[]): Promise<void> {
	return API_V1
		.delete(`/group/${groupId}/members/remove`, { params: { userIds, externalUserIds } });
}

export function getMemberInvitationDates(groupId: string, memberId: string, isTscUser: boolean): Promise<Date[]> {
	return API_V2.get(`/groups/${groupId}/admin/invitations/${memberId}?isTscUser=${isTscUser}`)
		.then(({ data }) => data as Date[]);
}

export interface InviteGroupMembersRequest {
	subject?: string;
	message?: string;
	inviteInternal: boolean;
	inviteExternal: boolean;
	emailExternal: boolean;
	colleagues: InviteColleagueRequest[];
	external: InviteExternalRequest[];
}

export interface InviteColleagueRequest {
	role: UserRole;
	userId: string;
}

export interface InviteExternalRequest {
	role: UserRole;
	email: string;
	firstName: string;
	lastName: string;
}

export function inviteGroupMembers(groupId: string, params: InviteGroupMembersRequest): Promise<void> {
	return API_V1.post(`/group/${groupId}/members/invite`, params, { timeout: 0 });
}
